import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { RichTextComponent } from 'src/app/shared/components/rich-text/rich-text.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { toHTML } from 'ngx-editor';

@Component({
    selector: 'que-text-to-question',
    imports: [CommonModule, ReactiveFormsModule, MenuQuestionComponent, TranslateDirective, TranslatePipe, RichTextComponent, SvgIconComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TextToQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TextToQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './text-to-question.component.html',
    styleUrls: ['./text-to-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextToQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  #operationsStore = inject(MiniOperationsStore)
  @Output() focusEvent = new EventEmitter<boolean>();
  isExpand = false;
  #builder = inject(FormBuilder);
  questionForm = this.#builder.group({
    id: [-1],
    type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
    title: new FormControl<string>(''),
    additionalText: new FormControl<string>('', [Validators.required]),
    optionsList: new FormControl<OptionsList | null>(null),

    flex: new FormControl<string>('s'),
    requierd: new FormControl<boolean>(false),
    collectionQuestionId: new FormControl<number | null>(null),
    stepId: [-1],

  });
  orginalQuestion?:Question;
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      var html = question.additionalText?toHTML(JSON.parse(question.additionalText)):"";
      this.registerOnChangeCallback({...this.orginalQuestion, ...question ,html:encodeURI(html) });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  // writeValue(obj: String[]): void {
  //   this.optionsValue.patchValue({ op1:obj[0],op2:obj[1] }, { emitEvent: false });
  //   //this.onValidationChangeCallBack();xxx
  // }
  writeValue(obj: Question): void {
    this.orginalQuestion=obj;
    this.questionForm.patchValue({ ...obj }, { emitEvent: false });
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  // flex(flexChar: string) {
  //   this.menuOpened(true);
  //   this.questionForm.controls.flex.setValue(flexChar)
  // }
  expandEditor(ev: boolean) {
    this.isExpand = ev;
  }
}

